// Every version so far has been reported to Bugsnag with a "-stable" suffix, since the paper.js beta
// was a separate build that reported "-beta". The suffix stays so that versions still group.
export const version = `${__APP_VERSION__}-stable`;
